import { Rows3Icon, SquareIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { NAMESPACES } from "@/i18n/constants";
import { getPanelComposition } from "./panel-composition";
import { useSpec } from "./spec-context";

export function PanelLayoutToggle() {
    const { spec, dispatch } = useSpec();
    const { t } = useTranslation(NAMESPACES.FEATURES.DATA_VIEWER, { keyPrefix: "panel-layout-toggle" });

    const composition = getPanelComposition(spec);
    if (composition === "fixed") return null;

    const stacked = composition === "stacked";
    const label = stacked ? t("switch-to-single") : t("switch-to-stacked");

    return (
        <Button
            aria-label={label}
            aria-pressed={stacked}
            onClick={() => dispatch({ type: stacked ? "merge-panels" : "split-panels-by-category" })}
            size={"icon-sm"}
            tooltip={label}
            variant={"outline"}
        >
            {stacked ? <SquareIcon /> : <Rows3Icon />}
        </Button>
    );
}
